// extracted by mini-css-extract-plugin
export default {"dialog":"lOjwcQ4K_l2eqcDgluem","header":"Cu7ABmwChgbk7Z0od1KD","title":"i_vgrHmLbr9rqzlHpW_6","body":"aiRsRN2RIdX5WX6U0SX7"};